/**
 * Engine.IO transport failures. These are not rulings: the string is what
 * the browser shows when long-polling or the websocket drops ("xhr poll error").
 */
const TRANSPORT_ERRORS = new Set([
  'xhr poll error',
  'xhr post error',
  'websocket error',
  'timeout',
  'transport error',
  'connect_error',
  'server error',
])

export function isSocketTransportError(message: string): boolean {
  return TRANSPORT_ERRORS.has(message.trim().toLowerCase())
}
